import { createSelector } from 'reselect';
import _ from 'lodash';

/**
 * Wyswietla strony w odpowiedniej kolejnosci
 * @param {array} list - tablica z lista stron
 * @param {object} byId - lista wszystkich dostepnych stron
 */
export const getPages = createSelector(
    [(state) => state.list, (state) => state.byId],
    (list, byId) => _.pick(byId, list)
);

/**
 * Wyswietla id
 * @param {array} list - tablica z lista stron
 * @param {object} byId - lista wszystkich dostepnych stron
 */
export const getWidgetsOrderOnPage = createSelector(
    [(state) => state.pages.byId, (state) => state.pages.activeId],
    (pages, activeId) => pages[activeId].widgets
);

/**
 * Pobiera "zainstalowane" na stronie widgety
 * @param {number} activeId - id aktualnej strony
 * @param {object} pages - lista wszytskich stron
 * @param {object} widgets - lista wszystkich widgetow
 */
export const getWidgetsOnPage = createSelector(
    [(state) => state.pages.activeId, (state) => state.pages.byId, (state) => state.widgets.byId],
    (activeId, pages, widgets) => {
        const widgetsOnPageIds = pages[activeId].widgets;
        return _.pick(widgets, widgetsOnPageIds);
    }
);

/**
 * Zwraca typy widgetow zainstalowanych na stronie
 * @param {object} widgets - lista widgetow zainstalowanych na stronie,
 * @returns {Array} widgetsTypesArr - tablica z id szablonow dla widgetow
 */
export const getWidgetsTypesOnPage = createSelector(
    [getWidgetsOnPage],
    (widgets) => {
        const widgetsTypesArr = [];
        _.map(widgets, (widget) => {
            widgetsTypesArr.push(widget.template);
        });
        return widgetsTypesArr;
    }
);


/**
 * Pobiera aktualnie zaznaczony widget
 */
export const getFocusedWidget = createSelector(
    [(state) => state.widgets.activeWidget, (state) => state.widgets.byId],
    (activeWidget, widgets) => widgets[activeWidget]
);

/**
 * Sprawdza czy na stronie zainstalowane sa widgety posiadajace value
 * @param {object} widgets - lista widgetow zainstalowanych na stronie
 * @returns {bool} hasValue
 */
export const hasValueWidgetsOnPage = createSelector(
    [getWidgetsOnPage],
    (widgets) => {
        let hasValue = false;
        _.forEach(widgets, (widget) => {
            if (widget.hasValue === true) {
                hasValue = true;
            }
        });
        return hasValue;
    }
);

/**
 * Znajduje pierwszą stronę z nie wypelnionymi danymi
 */
export const getFirstPageWithEmptyResults = createSelector(
    [(state) => state.pages.byId, (state) => state.widgets.byId, (state) => state.results, (state) => state.pages.list],
    (pages, widgets, results, pagesList) => {
        const pageWithValue = [];
        const pageWithNoResults = [];
        _.forEach(pages, (page) => {
            _.forEach(page.widgets, (id) => {
                if (widgets[id].hasValue) {
                    pageWithValue.push(page.id);
                }
            });
        });

        pageWithValue.forEach((id) => {
            if (!_.has(results, id)) {
                pageWithNoResults.push(id);
            }
        });

        return _.head(_.intersectionWith(pagesList, pageWithNoResults, _.isEqual));
    }
);



// WEBPACK FOOTER //
// ./src/_app/quick_response/selectors/selectors.js